import styled from 'styled-components';

export const SpaceWrapper = styled.div`
    background: var(--blue);
    width: 100%;
    height: 200px;
`;